export const environment = {
  production: false,
  features: {
    entityTags: false,
    entityFileMultimediaFlow: true,
    roadshow: true,
    hackathon: true
  },
  okta: {
    authConfig: {
      issuer: 'https://onentt.okta.com/oauth2/ausf3mzucjRGKYWLy417',
      clientId: '0oafbxeqmbkQ7ydpU417',
      redirectUri:
        'https://ada-suite-frontend-dev.deptapps-instances.automation-coe.com/login/callback',
      scopes: ['openid', 'offline_access']
    },
    interceptor: {
      urls: [
        'https://ada-suite-frontend-dev.deptapps-instances.automation-coe.com'
      ]
    }
  },
  backend: {
    'AXET-CORE':
      'https://ada-suite-frontend-dev.deptapps-instances.automation-coe.com/axet-core-pre',
    'ADA-API':
      'https://ada-suite-frontend-dev.deptapps-instances.automation-coe.com/api-dev',
    'AUTOMATION-TOOLS':
      'https://ada-suite-frontend-dev.deptapps-instances.automation-coe.com/api-dev'
  },
  axetPortal: 'https://axet-pre.nttdata.com',
  sso: '/sso'
};
